import CkEditorUI from "./CkEditorUI.jsx";
import { ckEditorConfiguration } from "../utils/utils";

const EmailInvitationBody = ({ emailBody, handleEditorChange }) => (
  <div className="form-group row">
    <label className="col-sm-3 form-control-label label">
      Invitation Email Body
    </label>
    <div className="col-sm-9 email-editor fields-font">
      <CkEditorUI
        name="body"
        id="body"
        title="Body"
        variant="outlined"
        data={emailBody}
        handleEditorChange={handleEditorChange}
        editorConfiguration={ckEditorConfiguration.forClassManagement}
      />
    </div>
  </div>
);

export default EmailInvitationBody;
